export default "__VITE_ASSET__BXwmBhMU__"